import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import CertificationsTab   from "./tabs/CertificationsTab";
import RTWTab              from "./tabs/RTWTab";
import DBSTab              from "./tabs/DBSTab";
import IR35Tab             from "./tabs/IR35Tab";
import CISTab              from "./tabs/CISTab";
import COSHHTab            from "./tabs/COSHHTab";
import AccidentsTab        from "./tabs/AccidentsTab";
import LoneWorkerTab       from "./tabs/LoneWorkerTab";
import InsurancesTab       from "./tabs/InsurancesTab";
import ScaffoldTab         from "./tabs/ScaffoldTab";
import WasteTab            from "./tabs/WasteTab";

const TABS = [
  { key: "certs",     label: "Certifications" },
  { key: "rtw",       label: "Right to Work" },
  { key: "dbs",       label: "DBS Checks" },
  { key: "ir35",      label: "IR35" },
  { key: "cis",       label: "CIS" },
  { key: "coshh",     label: "COSHH" },
  { key: "accidents", label: "Accidents" },
  { key: "lone",      label: "Lone Worker" },
  { key: "insurance", label: "Insurances" },
  { key: "scaffold",  label: "Scaffold" },
  { key: "waste",     label: "Waste" },
];

export default function CompliancePage() {
  const { companyId } = useParams<{ companyId: string }>();
  const cid = Number(companyId);
  const navigate = useNavigate();
  const [tab, setTab] = useState("certs");

  const renderTab = () => {
    switch (tab) {
      case "certs":     return <CertificationsTab   cid={cid} />;
      case "rtw":       return <RTWTab              cid={cid} />;
      case "dbs":       return <DBSTab              cid={cid} />;
      case "ir35":      return <IR35Tab             cid={cid} />;
      case "cis":       return <CISTab              cid={cid} />;
      case "coshh":     return <COSHHTab            cid={cid} />;
      case "accidents": return <AccidentsTab        cid={cid} />;
      case "lone":      return <LoneWorkerTab       cid={cid} />;
      case "insurance": return <InsurancesTab       cid={cid} />;
      case "scaffold":  return <ScaffoldTab         cid={cid} />;
      case "waste":     return <WasteTab            cid={cid} />;
      default:          return null;
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => navigate(-1)} className="text-violet-600 hover:text-violet-800 flex items-center gap-1 text-sm">
          <ArrowLeft size={16} /> Back
        </button>
        <div>
          <h1 className="text-xl font-semibold text-slate-800 flex items-center gap-2">
            <ShieldCheck size={20} className="text-violet-600" /> UK Compliance — Company #{cid}
          </h1>
          <p className="text-xs text-slate-500">Section 17 · UK FSM Compliance & HR</p>
        </div>
      </div>

      <Tabs
        activeKey={tab}
        onChange={setTab}
        type="card"
        size="small"
        className="mb-0"
        items={TABS.map((t) => ({ key: t.key, label: t.label, children: null }))}
      />
      <div className="bg-white rounded-b-xl border border-slate-100 border-t-0 shadow-sm p-4 mt-0">
        {renderTab()}
      </div>
    </div>
  );
}
